export default __webpack_public_path__ + "static/media/PPLogo.a02b76aa.png";